<template>
  <BaseCard
    class="group relative w-full cursor-pointer overflow-hidden p-4"
    @click="emit('open', survey.id)"
  >
    <div>
      <p v-if="survey.title" class="text-body-medium text-on-surface-variant truncate">
        {{ survey.feedbackTopic.title }}
      </p>
      <h4 class="text-title-large leading-tight">
        {{ survey.title ?? survey.feedbackTopic.title }}
      </h4>
      <CoachSurveyRecurringInformation
        class="my-2"
        :recurrence="survey.recurrence"
        :createdAt="survey.createdAt"
        :numberOfSurveys="survey.occurrences.length"
        :show-created-at="false"
      />
      <div class="mt-4 flex w-full flex-row items-center">
        <div class="grow overflow-x-auto">
          <ul class="flex flex-row gap-0.5">
            <li
              v-for="occurrence in survey.occurrences"
              :key="occurrence.id"
              v-tooltip="useDisplayDate(occurrence.startDate, { dayName: 'short' }).value"
            >
              <div
                class="flex h-8 w-6 items-center justify-center rounded-full"
                :class="[
                  occurrence.hasAnswered && 'bg-primary-container text-on-primary-container',
                  !occurrence.hasAnswered && 'bg-surface-container-highest',
                ]"
              >
                <BaseIcon v-if="occurrence.hasAnswered" size="20">check</BaseIcon>
              </div>
            </li>
          </ul>
        </div>

        <div class="flex shrink-0 flex-col">
          <span class="text-body-medium text-on-surface-variant">
            {{ answeredCount }}/{{ survey.occurrences.length }}
          </span>
        </div>
      </div>
    </div>
    <BaseStateLayer />
  </BaseCard>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import BaseCard from '@/core/components/base/card/BaseCard.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import CoachSurveyRecurringInformation from '@/modules/coach-surveys/components/CoachSurveyRecurringInformation.vue'
  import type { CoacheeTodos } from '../composables/useCoacheeTodos'

  interface Props {
    survey: CoacheeTodos['coacheeSurveys'][number]
  }

  const { survey } = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'open', surveyId: string): void
  }>()

  const answeredCount = computed(
    () => survey.occurrences.filter((occurrence) => occurrence.hasAnswered).length,
  )
</script>
